import type { IAddConversationNoteCallingActionPayload } from 'entities/AICalling/api/types.ts'
import type { IMessageActionData } from 'entities/TemplateActions/actions.tsx'
import { addConversationNote } from 'widgets/TemplateActions/addConversationNote'
import { type AgentInstructionsStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/AgentInstructions/store/AgentInstructionsStore.tsx'
import { createAddConversationNoteCallingAction } from './createAddConversationNoteCallingAction.ts'

export const onAddConversationNoteChipClick =
  (store: AgentInstructionsStore) => (chip: HTMLSpanElement, data: IMessageActionData) => {
    const { getAgentAction, onUpdateAgentAction, deleteChipAndAgentAction, entities } = store
    let action: IAddConversationNoteCallingActionPayload | undefined

    if ('token_id' in data) {
      const token_id = data.token_id
      const findAction = getAgentAction(token_id)

      if (token_id) {
        if (findAction?.action_type === 'add_conversation_note') {
          action = findAction
        }
      }
    }
    if (action) {
      return addConversationNote(
        {
          onSave: (data) =>
            onUpdateAgentAction(
              createAddConversationNoteCallingAction(data, action.settings.token_id)
            ),
          onDelete: () => deleteChipAndAgentAction(chip, action),
          data: action.settings,
        },
        entities
      )
    }
  }
